import React, { useState, createContext, useEffect } from "react";
import styled from "styled-components";
import { ClientType } from "@/services/UserService";
import { getToken } from "@/services/TokenServce";
import { AuthService } from "@/services/AuthService";

export const AccountContext = createContext<{
  hasToken: boolean
  loading: boolean
  setHasToken: (e: boolean) => void,
  state: string
  account: ClientType | null
  setAccount: (e: object) => void
  setState: (e: string) => void
}>({
  hasToken: false,
  loading: false,
  setHasToken: () => {},
  state: null,
  setState: () => {},
  account: null,
  setAccount: () => {},
})

const AccountProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [hasToken, setHasToken] = useState(false)
  const [state, setState] = useState<string>('login')
  const [account, setAccount] = useState(null)

  useEffect(() => {
    const fetchToken = async () => {
      setLoading(true)
      const token = getToken()
      if(token){
        setHasToken(true)
        try {
          const { status } = await AuthService.verify()
          if(status === "active"){
            setState('account')
          }else if (status === "confirm_phone"){
            setState('verify')
          }
        }catch (e){
          console.log("[ERROR AuthService.verify API]", e)
        }
      }
      setLoading(false)
    }

    fetchToken()
  }, [])

  return (
    <AccountContext.Provider
      value={{
        hasToken,
        loading,
        setHasToken,
        state,
        setState,
        account: account,
        setAccount: setAccount,
      }}
    >
      {children}
    </AccountContext.Provider>
  )
}

export default AccountProvider

const ScreenWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`
